export class PucaPACModel {
	isHatAvailable: string = "0";
	isTutionFeeWaiver: string = "2";
	isGreSelected: boolean = false;
	isGMATSelected: boolean = false;
	isTOEFELSelected: boolean = false;
	isIELTSSelected: boolean = false;
}

export class PucaTestModel {
	testTypeCodeId: number;
	testDate: string;
	totalScore: number;
	obtainedScore: number;
	percentile: number;
}
